import MentionsLegales from "../components/mentions-legales/mention-legales";

const Main = () => {
  return (
    <section className="main-section" id="main">
      <MentionsLegales />
    </section>
  );
};

export default Main;
